import React, { useState } from 'react';
import { toast } from 'react-toastify';
import OpportunityInfoTab from './OpportunityInfoTab';
import DocumentsTab from '../opportunity-documents/DocumentsTab.jsx';

const OpportunityDetails = ({oppData}) =>{
    const [activeTab, setActiveTab] = useState(0);
    
    let tabs =  ["Qualification", "Information Gathering", "Documents", "Conversion"];

    if (oppData.funnel === 'Re-KYC'){
        tabs = ["Qualification", "Documents"];
    }
    return(
        <div className="w-full flex justidy-between items-center ml-2">
            <div className="p-4 rounded-3xl w-full mr-2">
                <div className="flex space-x-6 ml-3">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveTab(index);
                            }}
                            className={`relative text-md font-medium pb-1 transition-all mb-3 ${
                                activeTab === index ? "text-black border-b-4 pl-2 pr-2 border-yellow-300" : "text-gray-500"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {activeTab === 0 && (
                    <div className="w-full bg-white p-7 rounded-3xl shadow-lg">
                        <div className="flex justify-between items-start">
                            <div className="flex items-center">
                                <p className="font-bold text-2xl text-[#1E293B]">Qualification</p>
                            </div>
                        </div>
                        <div className="flex items-center mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/5 font-bold text-[#475569]">MM Account ID</span>
                                <span className="flex-1 text-[#475569]">{oppData.mm_acc_id}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.mm_acc_id);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        <div className="flex items-center mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/5 font-bold text-[#475569]">Opportunity Remark</span>
                                <span className="flex-1 text-[#475569]">{oppData.opp_name}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.opp_name);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        <div className="flex items-center mt-5">
                            <span className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/5 font-bold text-[#475569]">Account Name</span>
                                <span className="flex-1 text-[#475569]">{oppData.name}</span>
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(oppData.name);
                                        toast.success('Copied to clipboard!');
                                    }}
                                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <img src="/icons/content_copy.svg" className='size-6'/>
                                </button>
                            </span>
                        </div>
                        {(oppData.funnel === 'Insurance') && (
                            <div className="flex items-center mt-5">
                                <span className="border-b border-gray-200 pb-2 w-full flex">
                                    <span className="w-1/5 font-bold text-[#475569]">Ref ID</span>
                                    <span className="flex-1 text-[#475569]">{oppData?.ref_id || "N/A"}</span>
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(oppData?.name);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </span>
                            </div>
                        )}
                    </div>
                )}
                {activeTab === 1 && (
                    oppData.funnel === 'Re-KYC' ? (
                        <DocumentsTab oppData={oppData} />
                    ) : (
                        <OpportunityInfoTab oppData={oppData} />
                    )
                )}
                {activeTab === 2 && (
                    <DocumentsTab leadID={oppData.lead_id} funnel = {oppData.funnel}/>
                )}
                {activeTab === 3 && (
                    <div>
                        Conversion Tab Content
                    </div>
                )}
            </div>
        </div>
    )
};
export default OpportunityDetails;